const React = require('react');

const SidebarUpsellPlaceholder = () => (
  <li className="upsell__card">
    <div className="upsell__card__img">
      <div className="upsell__card__img__link"></div>
    </div>
    <div className="upsell__card__description">
      <div className="placeholder-p mb-half "></div>
      <div className="product-card__price">
        <div className="placeholder-p quarter-width "></div>
      </div>
    </div>
  </li>
);

module.exports = SidebarUpsellPlaceholder;



// WEBPACK FOOTER //
// ./javascripts/components/product_show_page/sidebar_upsell_placeholder.jsx